import { styled } from 'baseui'
import { FlexCenter, FlexBetween, FlexColumn } from '@/shared/theme/styled-components'

export const FeedbackButton = styled(FlexCenter, ({ $theme, $active, disabled }) => ({
  flex: 1,
  padding: '0.75rem 0',
  borderRadius: '0.5rem',
  border: `0.0625rem solid ${$theme.colors.borderMedium}`,
  backgroundColor: $active ? $theme.colors.bgHover : $theme.colors.white,
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: disabled ? 'not-allowed' : 'pointer',
  gap: '0.5rem',
  opacity: disabled ? 0.5 : 1,
  filter: disabled ? 'grayscale(70%) brightness(0.93)' : 'none',
  background: disabled ? $theme.colors.bgDisabled : ($active ? $theme.colors.bgHover : $theme.colors.white),
  color: disabled ? $theme.colors.textDisabled : $theme.colors.textBody,
  borderColor: disabled ? $theme.colors.mono300 : $theme.colors.mono300,
}))

export const QuestionText = styled('p', ({ $theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: $theme.colors.textBody,
  margin: '0.75rem 0 0.25rem',
}))

export const FeedbackButtonsRow = styled(FlexBetween, {
  gap: '1rem',
  width: '100%',
})

export const SuccessContainer = styled(FlexColumn, {
  alignItems: 'center',
  gap: '2rem',
  paddingTop: '2rem',
  paddingBottom: '1rem',
})

export const SuccessMessage = styled('p', ({ $theme }) => ({
  fontSize: '1.125rem',
  fontWeight: '600',
  color: $theme.colors.successAlt,
  lineHeight: '1.5rem',
  textAlign: 'center',
  marginTop: '1rem',
}))